import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { Fetch } from "../../../../shared/Fetch";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Toolbar } from "primereact/toolbar";
import { IPermissionProps } from "../../../../models/Login";

interface IProps {
    setModal: (modal: { open: boolean, singleData: ITopic }) => void,
    permissions: IPermissionProps,
    reload: boolean,
    toast: any,
    openQuestionModal: (topic_ID: number) => void
}

export interface ITopic {
    topic_ID?: number,
    topic_Name?: string,
    topic_Description?: string,
    topic_Status?: boolean,
    added_By?: string,
    added_On?: Date,
    updated_By?: string,
    updated_On?: Date,
}

const emptyTopic: ITopic = {
    topic_Name: "",
    topic_Description: "",
    topic_Status: true
};

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ITopic[], loading: boolean });
    const dt = useRef<any>(null);

    const action = (rowData: ITopic) => {
        return (
            <div className="flex gap-3">
                {props.permissions.is_Update && <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>}
                {props.permissions.is_Update && <Button className="pi pi-external-link text-primary bg-white border-none" onClick={() => props.openQuestionModal(rowData.topic_ID!)} />}
                {/* <Button className="pi pi-trash bg-white border-none" style={{ color: "red" }} onClick={() => confirmDelete(rowData)}></Button> */}
            </div>
        );
    };

    const openEdit = (data: ITopic) => props.setModal({ open: true, singleData: data });

    const confirmDelete = (rowData: ITopic) => {
        confirmDialog({
            message: `Are you sure you want to delete this Topic`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveTeam(rowData),
            reject: () => props.toast.current.show({ severity: "error", detail: "Cancelled", life: 3000 })
        });
    };

    const RemoveTeam = async (rowData: ITopic) => {
        const response = await Fetch("CarnivalTraining/removeTopic", "DELETE", null, `topic_ID=${rowData.topic_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Removed", life: 3000 });
            loadTableData();
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getTopic", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const onToggle = async (data: ITopic) => {
        const method = "PUT";
        const message = "Updated Successfully";
        const url = "toggleTopicStatus";
        delete data.added_On;
        delete data.added_By;
        delete data.updated_On;
        delete data.updated_By;

        const response = await Fetch(("CarnivalTraining/" + url), method, data, null, props.toast);

        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    }

    const status = (data: ITopic) => {
        return <p className="cursor-pointer underline" onClick={() => {
            if (props.permissions.is_Update) { onToggle(data); }
        }} style={{ color: (data.topic_Status === true ? "green" : "red") }}>{data.topic_Status === true ? "Active" : "Inactive"}</p>
    }
    const fromDate = (rowData: ITopic) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toDate = (rowData: ITopic) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={() => {
                return (props.permissions.is_Create ? <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => props.setModal({ open: true, singleData: emptyTopic })} /> : <></>)
            }}></Toolbar>

            <DataTable value={tableData.tableData} loading={tableData.loading} header={<p>Training Topics</p>}>
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="topic_Name" header="Topic" />
                <Column field="topic_Description" header="Description" />
                <Column field="added_By" header="Added By" />
                <Column field="added_On" header="Added On" body={(rowData: ITopic) => fromDate(rowData)} />
                <Column field="updated_By" header="Updated By" />
                <Column field="updated_On" header="Updated On" body={(rowData: ITopic) => toDate(rowData)} />
                <Column field="topic_Status" header="Status" body={status} />
                <Column header="Action" body={action} />
            </DataTable>

            <ConfirmDialog />
        </>
    );
};
